import axios from 'axios';
import { redirectToLogin } from './auth';
import { notification } from 'antd';
import Cookies from 'js-cookie';
import { buildServiceUrl } from '../config';

const instance = axios.create();

instance.defaults.headers.common['x-lang'] = 'eng';

instance.interceptors.request.use(
    config => {
        const token = Cookies.get('obs-token');

        if (token !== undefined) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        const RISK_PROXY_SERVICE_URL = buildServiceUrl(
            process.env.REACT_APP_RISK_PROXY_SERVICE_PREFIX,
            process.env.REACT_APP_RISK_PROXY_SERVICE_SUFFIX,
        );

        if (config.url?.startsWith(RISK_PROXY_SERVICE_URL)) {
            config.withCredentials = true;
        }

        return config;
    },
    error => {
        return Promise.reject(error);
    },
);

// Add a response interceptor
instance.interceptors.response.use(
    function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    },
    function (error) {
        if (error.response?.status === 401) {
            redirectToLogin();
        } else if (error.message === 'Network Error') {
            notification.error({
                message: 'Network error. Request timed out.',
            });
        }
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        return Promise.reject(error);
    },
);

export default instance;
